import { colors } from '../colors'

export default {
  height: '3rem',
  backgroundColor: `${colors.toolbar.backgroundColor}`,
  backgroundColorDark: `${colors.toolbar.backgroundColorDark}`,
  fontFamily: `Helvetica Neue, helvetica, arial, verdana, sans-serif;`,
  textColor: `${colors.toolbar.textColor}`
}
